export const STANDARD_EXPENSE_ACCOUNTS = [
  'Advertising And Marketing',
  'Automobile Expense',
  'IT and Internet Expenses',
  'Lodging',
  'Meals and Entertainment',
  'Office Supplies',
  'Travel Expense',
  'Other Expenses',
]

const STORAGE_KEY = 'shipsedge_custom_expense_accounts'

export const getCustomAccountTypes = (): string[] => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (raw) {
      const parsed = JSON.parse(raw)
      if (Array.isArray(parsed)) {
        return parsed.filter(
          (x) => typeof x === 'string' && x.trim() && !STANDARD_EXPENSE_ACCOUNTS.includes(x.trim())
        )
      }
    }
  } catch (e) {
    console.error('Failed to parse custom account types', e)
  }
  return []
}

export const saveCustomAccountType = (name: string): string[] => {
  const trimmed = name.trim()
  if (!trimmed || STANDARD_EXPENSE_ACCOUNTS.includes(trimmed)) {
    return getCustomAccountTypes()
  }
  const existing = getCustomAccountTypes()
  if (!existing.some((a) => a.toLowerCase() === trimmed.toLowerCase())) {
    const updated = [...existing, trimmed]
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(updated))
    } catch (e) {
      console.error('Failed to save custom account type', e)
    }
    return updated
  }
  return existing
}

export const isCustomAccountType = (accountName?: string | null): boolean => {
  if (!accountName) return false
  const trimmed = accountName.trim()
  if (!trimmed || trimmed === '-') return false
  return !STANDARD_EXPENSE_ACCOUNTS.includes(trimmed)
}

